import api from '@/services/api'
import store from '@/store/index'
// import { camelToSnake } from '@/services/utils/index'

// import Auth from '../auth/index'
import { apiErrorHandler } from '../utils/apiErrors'

const PHOTO_ENDPOINT = 'photos/'

export default class PhotoAPI {
  /**
   * Instantiate a new `PhotoAPI`
   * @param {class} cls - The class to use to create objects.
   */
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `PhotoAPI`.
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new PhotoAPI(cls)
  }

  /* Get the API Client. */
  get client() {
    return api.getApiClient()
  }

  /**
   * Create a new Event through the API.
   * @param {Event} event - Data for the event to be created.
   * @returns {Promise} - Promise wrapping the newly-created `Event` data.
   **/
  async create(projectId, file) {
    const url = PHOTO_ENDPOINT
    const options = {
      headers: {
        ...store.getters.getHeaders,
        'Content-Type': 'multipart/form-data',
      },
    }
    /* eslint-disable-next-line */
    const data = new FormData()
    data.append('photo', file)
    data.append('project', projectId)

    return this.client
      .post(url, data, options)
      .then(response => this.cls.fromAPI(response.data))
      .catch(apiErrorHandler({ apiName: 'Create photo API error' }))
  }

  /**
   * Create a new Event through the API.
   * @param {Event} event - Data for the event to be created.
   * @returns {Promise} - Promise wrapping the newly-created `Event` data.
   **/

  //  TODO: I can combine this with the function above, but I don't know where that has been used
  // I will update that later when I'm cleaning all this up.

  async createPhotoWithUpdate(updateId, file) {
    const url = PHOTO_ENDPOINT
    const options = {
      headers: {
        ...store.getters.getHeaders,
        'Content-Type': 'multipart/form-data',
      },
    }
    /* eslint-disable-next-line */
    const data = new FormData()
    data.append('photo', file)
    data.append('update', updateId)

    return this.client
      .post(url, data, options)
      .then(response => this.cls.fromAPI(response.data))
      .catch(apiErrorHandler({ apiName: 'Create photo API error' }))
  }

  /**
   * Update an project through the API.
   *
   * @param {project} project - The event to update.
   * @param {Array} fields - List of fields to include in update, others will be ignored.
   * @param {Array} excludeFields - List of fields to exclude from update.
   *
   * @returns {Promise} - Promise object wrapping API response data.
   **/
  async update(photo, fields = []) {
    this.cls.checkIsInstance(photo, 'The `photo` argument')

    const url = `${PHOTO_ENDPOINT}${photo.id}/`
    const data = this.cls.toAPI(photo, fields)

    const promise = this.client.patch(url, data)
    return promise
      .then(response => this.cls.fromAPI(response.data))
      .catch(apiErrorHandler({ apiName: 'Update photo API error' }))
  }

  async delete(photo) {
    const url = `${PHOTO_ENDPOINT}${photo.id}/`
    return this.client.delete(url).catch(apiErrorHandler({ apiName: 'Delete photo API error' }))
  }
}
